
<div mat-dialog-title>{{dTitle}}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
    <div class="block">Listed below are the securities held in account {{accountNumber}} which make up this group
        security.
    </div>
    <div class="bold" style="margin-bottom: 5px;">Securities</div>
    <irb-inventory-grid
            [style.width]="'100%'"
            [style.height]="gridHeight"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [rowData]='rebalCompSecurityDTOList'
            (gridReady)="onGridReady($event)">
    </irb-inventory-grid>
</mat-dialog-content>
<mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-primary">Cancel</button>
</mat-dialog-actions>
